const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 179 245.3",
    enableBackground: "new -566.7274 -103 1664.797 507.0414",
    width: "12px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 255.659012, 121.868736)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M -141.191 69.875 C -152.989 46.455 -151.797 4.735 -150.811 -11.429 C -132.152 -12.709 -118.733 -16.242 -118.733 -20.407 C -118.733 -24.495 -131.65 -27.977 -149.767 -29.313 C -138.197 -35.277 -130.279 -47.331 -130.279 -61.243 C -130.279 -81.078 -146.351 -97.156 -166.186 -97.156 C -186.02 -97.156 -202.092 -81.078 -202.092 -61.243 C -202.092 -47.331 -194.171 -35.277 -182.604 -29.313 C -200.719 -27.977 -213.641 -24.495 -213.641 -20.407 C -213.641 -16.242 -200.215 -12.709 -181.56 -11.429 C -180.571 4.737 -179.379 46.455 -191.177 69.875 C -214.299 74.523 -230.525 85.436 -230.525 98.147 L -101.85 98.147 C -101.85 85.436 -118.052 74.52 -141.176 69.863 L -141.191 69.875 Z",
    style: {
      stroke: "rgb(7, 7, 7)",
      paintOrder: "stroke",
      strokeWidth: 50,
      fill: "rgb(255, 255, 0)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinYellow);
export default __webpack_public_path__ + "static/media/coinYellow.8f66742b2bd05431336636f08629962d.svg";
export { ForwardRef as ReactComponent };